<template>
    <el-container class="add-api">
        <el-main>
            <el-form>
                <div class="form-title">
                    <h3><i class="fa fa-plus-square" aria-hidden="true"></i> 添加 API</h3>
                    <div class="form-btn">
                        <el-button @click="addApi">添加</el-button>
                    </div>
                </div>
                <el-form-item label="交易所名称">
                    <el-select placeholder="请选择交易所" v-model="bourseSelect">
                        <el-option label="OKex" value="1"></el-option>
                        <el-option label="火币" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="API 名称">
                    <el-input v-model="apiName" placeholder="请填写API名称"></el-input>
                </el-form-item>
                <el-form-item label="交易所公钥">
                    <el-input v-model="apiKey" placeholder="填写交易所公匙"></el-input>
                </el-form-item>
                <el-form-item label="交易所私钥">
                    <el-input v-model="apiSecret" placeholder="请填写交易所私匙"></el-input>
                </el-form-item>
                <el-form-item label="API 密钥">
                    <el-input v-model="apiToken" placeholder="API密匙"></el-input>
                </el-form-item>
                <el-form-item label="API 密钥">
                    <el-input v-model="apiToken" placeholder="API密匙"></el-input>
                </el-form-item>
            </el-form>
        </el-main>
    </el-container>
</template>

<script>
/* eslint-disable */
import { get, post } from '@/api/index'
import { mapState } from 'vuex'
 
export default {
    data() {
        return {
            bourseSelect: '',
            apiName: '',
            apiKey: '',
            apiToken: '',
            apiSecret: '',
        }
    },
    computed: {
        ...mapState([
            'token'
        ])
    },
    methods: {
        // 添加 api 事件
        addApi() {
            let url = this.$baseUrl + '/api/add';
            let param = {
                'token': this.token,
                'name': this.apiName,
                'bourseId': this.bourseSelect,
                'apiKey': this.apiKey,
                'apiSecret': this.apiSecret,
                'apiToken': this.apiToken
            };
            
            post(url, JSON.stringify(param)).then(resp => {
                if (resp.code == 200) {
                    this.$notify.info({
                        message: '添加成功',
                        title: '提示',
                        offset: 100
                    })
                } else {
                    this.$notify.error({
                        message: resp.info,
                        title: '提示',
                        offset: 100
                    })
                }
            })
        }
    }
}
</script>

<style lang="scss">
    .add-api{
        // margin-left: 10px;
        input::-webkit-input-placeholder{
            color: #787979;
        }
        .el-main{
            background-color: #252425;
        }
        .el-form{
            width: 100%;
            margin: 0 auto;
            background-color: #2A2D2E;
            padding-bottom: 20px;
            border-radius: 5px;
            .form-title{
                padding: 10px;
                margin-bottom: 20px;
                border-bottom: 4px solid #787979;
                color: #787979;
                text-align: left;
                font-weight: 600;
                background-color: #1e1e1e;
                display: flex;
                justify-content: space-between;
            }
            .el-form-item{
                padding-left: 50px;
                width: 70%;
                margin: 20px auto;
            }
            .form-btn{
                text-align: right;
                // border-top: 1px solid #787979;
                // padding: 20px 10px 0 10px;
                .el-button{
                    background-color: #524e4e;
                    border-color: #524e4e;
                    color: #acadad;
                    padding: 7px 10px;
                }
                .el-button:hover{
                    background-color: #524e4e;
                    color: #fff;
                }
            }
            .el-form-item__label{
                min-width: 100px;
                font-weight: 600;
            }
            .el-input{
                width: 75%;
                .el-input__inner{
                    width: 75%;
                    background-color: #1e1e1e;
                    border-color: #1e1e1e;
                }
            }
            .el-select{
                width: 56%;
                .el-input{
                    width: 100% !important;
                }
                .el-input__inner{
                    width: 100%;
                }
            }
        }
    }
</style>
